<template>
  <Row>
    <Col :span="18">
      <CellGroup inset>
        <Field v-model="SearchQuery.likeQuery.goods_name" center placeholder="商品名称" clearable="true"/>
      </CellGroup>
    </Col>
<!--    <Col :span="9">-->
<!--      <CellGroup inset>-->
<!--        <Field v-model="SearchQuery.likeQuery.design_user_name" center placeholder="设计师"  clearable/>-->
<!--      </CellGroup>-->
<!--    </Col>-->
    <Col :span="6">
      <Button icon="search" color="var(--base-color)" @click="search" style="border-radius:5px">搜索</Button>
    </Col>
  </Row>
  <List
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="margin-top: 10px"
  >
    <CellGroup inset v-for="(item,index) in list" :key="item" style="margin-top: 10px">
      <Cell class="my-cell-title">
        <template #title>
          <span style="color:var(--base-color);">{{ index + 1 }}</span>
          商品名称：{{ item.goodsName }}
        </template>
      </Cell>
      <div>
        <Grid :column-num="2" :border="false">
          <GridItem class="show-data-gridItem" :text="`商品类型:${item.goodsCode}`"/>
          <GridItem class="show-data-gridItem" :text="`数量:${item.quantity}`"/>
          <GridItem class="show-data-gridItem" :text="`人民币:${item.rmb}`"/>
        </Grid>
      </div>
    </CellGroup>
  </List>
</template>

<script setup>
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Tag,
  Col,
  Row,
  Calendar,
  List,
  Grid, GridItem
} from 'vant';
import {onMounted, reactive, ref} from "vue";
import {getGoodsPage} from "@/api/goods";


//分页相关
let pageNum = ref(1)
let pageSize = ref(10)

let SearchQuery = reactive({
  likeQuery: {goods_name: ''},
})

const list = ref([]);
const loading = ref(false);
const finished = ref(false);

const onLoad = () => {
  getGoodsPage(SearchQuery, pageNum.value, pageSize.value).then(res => {
    if (res.data.records.length > 0) {

      pageNum.value++;
      list.value.push(...res.data.records)
      // 加载状态结束
      loading.value = false;
    } else {
      finished.value = true;
    }
  })
}

const search = () => {
  pageNum.value=0
  list.value.splice(0, list.value.length)
  onLoad()
}


onMounted(() => {
  // load()
})
</script>

<style scoped>

</style>
